export const isMobile = (window: Window) => window.matchMedia && window.matchMedia('(max-width: 767px)').matches

export const isDesktop = (window: Window) => window.matchMedia && window.matchMedia('(min-width: 1024px)').matches
